import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

const SpecialAgentModal = ({ show, onClose, onSubmit, agent }) => {
  const [formData, setFormData] = useState({
    logo: null,
    supportInfo: [{ mob: "", email: "", whatsappNo: "" }],
  });

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedSupportInfo = [...formData.supportInfo];
    updatedSupportInfo[index][name] = value;
    setFormData({
      ...formData,
      supportInfo: updatedSupportInfo,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      logo: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let logoUrl = "";
    if (formData.logo) {
      const uploadData = new FormData();
      uploadData.append("file", formData.logo);
      uploadData.append(
        "upload_preset",
        process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
      );

      const cloudRes = await fetch(
        process.env.REACT_APP_CLOUDINARY_UPLOAD_URL,
        {
          method: "POST",
          body: uploadData,
        }
      );

      const cloudData = await cloudRes.json();
      logoUrl = cloudData.secure_url;
    }
    console.log("agent", agent);
    const payload = {
      agentId: agent._id,
      supportInfo: formData.supportInfo,
      logoUrl, // send only the Cloudinary URL
    };

    onSubmit(payload);
  };
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full items-top max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">Promote to Special Agent</h3>
          <button onClick={onClose} className="text-gray-500">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Agent Logo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full p-2 border rounded"
            />
          </div>

          {formData.supportInfo.map((info, index) => (
            <div key={index} className="mb-4 border p-3 rounded">
              <h4 className="font-medium mb-2">Support Info #{index + 1}</h4>

              <div className="mb-2">
                <label className="block text-sm font-medium mb-1">Mobile</label>
                <input
                  type="text"
                  name="mob"
                  value={info.mob}
                  onChange={(e) => handleInputChange(e, index)}
                  className="w-full p-2 border rounded"
                />
              </div>

              <div className="mb-2">
                <label className="block text-sm font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={info.email}
                  onChange={(e) => handleInputChange(e, index)}
                  className="w-full p-2 border rounded"
                />
              </div>

              <div className="mb-2">
                <label className="block text-sm font-medium mb-1">
                  WhatsApp
                </label>
                <input
                  type="text"
                  name="whatsappNo"
                  value={info.whatsappNo}
                  onChange={(e) => handleInputChange(e, index)}
                  className="w-full p-2 border rounded"
                />
              </div>
            </div>
          ))}

          <div className="flex justify-end space-x-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-purple-600 text-white rounded"
            >
              Promote
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpecialAgentModal;
